import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import * as R from 'Router/routes';
import { Card, Checkbox, Link } from 'components';
import { TwButton } from 'components/TwButton/TwButton';
import H1 from 'components/H/H1';
import usePSD2Consents from './usePSD2Consents';

function SkeletonConsent() {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className="animate-pulse bg-background-accent h-4 w-full"
        />
      ))}
      <div className="animate-pulse bg-background-accent h-4 w-1/2 mb-7" />
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={i}
          className="animate-pulse bg-background-accent h-4 w-full"
        />
      ))}
      <div className="animate-pulse bg-background-accent h-4 w-1/3 mb-7" />
    </div>
  );
}

function PSD2Consents() {
  const { t } = useTranslation(['psd2_consents', 'psd2_guide', 'psd2_banks']);
  const {
    confirm,
    consentAccepted,
    handleConsentChange,
    isLoading,
    isPending,
    consentHTMLContent,
    isManual,
  } = usePSD2Consents();

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <H1 dataTest="psd2Consents-title">{t('page_title')}</H1>

      <Card
        className="flex-col mb-6 rounded-none lg:rounded-lg"
        dataTest="psd2Consents-card"
      >
        <Checkbox
          dataTest="psd2Consents-checkbox"
          name="consent"
          onChange={handleConsentChange}
          value={consentAccepted}
          expand
        >
          {isLoading && <SkeletonConsent />}
          <div
            className="leading-[1.75] mb-6"
            dangerouslySetInnerHTML={{
              __html: consentHTMLContent,
            }}
            data-test="psd2Consents-checkbox-text"
          />
        </Checkbox>
        <TwButton
          className="md:ml-9"
          onClick={confirm}
          data-test="psd2Consents-button"
          disabled={
            !consentHTMLContent || isLoading || !consentAccepted || isPending
          }
          pending={isPending}
        >
          {t('psd2_banks:continue')}
        </TwButton>
      </Card>

      {!sessionStorage.getItem('psd2Token') && (
        <Link
          className="flex text-primary mx-auto lg:mx-0 mb-10 hover:underline text-left w-fit"
          data-test="psd2Consents-back"
          to={isManual ? R.MANUAL_PSD2_BANKS : R.PSD2_BANKS}
        >
          {t('psd2_guide:back')}
        </Link>
      )}
    </>
  );
}

export default PSD2Consents;
